/* ============================================================
   MAISON CANDELIA — quiz.js
   Quiz olfactif interactif — 4 étapes
   Les résultats sont des vrais produits Shopify (AJAX API)
   v4 : fix interaction (délégation d'événement sur .quiz-options)
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {
  const steps        = document.querySelectorAll('.quiz-step');
  const results      = document.querySelector('.quiz-results');
  const progressFill = document.querySelector('.quiz-progress__fill');
  const progressText = document.querySelector('.quiz-progress__text');
  if (!steps.length) return;

  let current = 0;
  const answers = {};

  // ---- Config recommandations selon les réponses ----
  function getRecommendationConfig() {
    const ambiance = answers[0]; // cocooning | voyage | nature | gourmand
    const objectif = answers[3]; // solo | coffret | cadeau | decouverte

    // Coffret ou cadeau → page cadeaux
    if (objectif === 'coffret' || objectif === 'cadeau') {
      return {
        productTypes: ['Coffret Cadeau'],
        collection:   'coffrets-idees-cadeaux-maison-candelia',
        label:        'COFFRETS CADEAUX'
      };
    }

    // Solo, découverte, et tout le reste → bougies de la collection voyage
    // (la collection ambiance contient fondants/poudres/diffuseurs, pas de bougies)
    const isAmbiance = (ambiance === 'cocooning' || ambiance === 'gourmand');
    return {
      productTypes: ['Bougie Parfumé Jesmonite', 'Bougie Parfumé'],
      collection:   'voyage',
      label:        isAmbiance ? 'COLLECTION AMBIANCE' : 'COLLECTION VOYAGE'
    };
  }

  // ---- Fetch tous les produits du shop ----
  function fetchAllProducts() {
    return fetch('/products.json?limit=250')
      .then(function (res) { return res.ok ? res.json() : { products: [] }; })
      .then(function (data) { return data.products || []; })
      .catch(function () { return []; });
  }

  // ---- Fetch depuis une collection ----
  function fetchFromCollection(handle) {
    return fetch('/collections/' + handle + '/products.json?limit=12')
      .then(function (res) { return res.ok ? res.json() : { products: [] }; })
      .then(function (data) { return data.products || []; })
      .catch(function () { return []; });
  }

  // ---- Détecter si un produit est une bougie solo ----
  function isBougie(p) {
    var type  = (p.product_type || '').toLowerCase();
    var title = (p.title || '').toLowerCase();
    // Exclusions explicites
    if (title.indexOf('poudre') !== -1)     return false;
    if (title.indexOf('fondant') !== -1)    return false;
    if (title.indexOf('diffuseur') !== -1)  return false;
    if (title.indexOf('suspension') !== -1) return false;
    if (title.indexOf('recharge') !== -1)   return false;
    if (title.indexOf('pack') !== -1)       return false;
    if (title.indexOf('box') !== -1)        return false;
    if (title.indexOf('kit') !== -1)        return false;
    if (title.indexOf('coupe') !== -1)      return false;
    if (title.indexOf('br\u00fbleur') !== -1 || title.indexOf('bruleur') !== -1) return false;
    if (title.indexOf('coffret') !== -1)    return false;
    if (title.indexOf('carte') !== -1)      return false;
    if (type.indexOf('accessoire') !== -1)  return false;
    if (type.indexOf('fondant') !== -1)     return false;
    if (type.indexOf('coffret') !== -1)     return false;
    // Inclure uniquement les bougies
    if (type.indexOf('bougie') !== -1)      return true;
    if (title.indexOf('bougie') !== -1)     return true;
    return false;
  }

  function isCoffret(p) {
    var type  = (p.product_type || '').toLowerCase();
    var title = (p.title || '').toLowerCase();
    return type.indexOf('coffret') !== -1 || title.indexOf('coffret') !== -1;
  }

  // ---- Récupérer les recommandations ----
  function getProducts(config) {
    var wantCoffrets = (config.label === 'COFFRETS CADEAUX');

    return fetchFromCollection(config.collection)
      .then(function (colProducts) {
        var filtered = colProducts.filter(wantCoffrets ? isCoffret : isBougie);
        if (filtered.length >= 2) return filtered;

        return fetchAllProducts().then(function (all) {
          var result = all.filter(wantCoffrets ? isCoffret : isBougie);
          if (result.length > 0) return result;
          return all.filter(function (p) {
            var type = (p.product_type || '').toLowerCase();
            return type.indexOf('acc\u00e9ssoires') === -1 &&
                   type.indexOf('accessoire') === -1 &&
                   type.indexOf('fondant') === -1;
          });
        });
      });
  }

  // ---- Shuffle ----
  function shuffle(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = arr[i]; arr[i] = arr[j]; arr[j] = tmp;
    }
    return arr;
  }

  // ---- Rendre les cartes produits ----
  function renderCards(grid, products, label) {
    grid.innerHTML = products.slice(0, 3).map(function (p) {
      const imgSrc = p.images && p.images[0] ? p.images[0].src : '';
      const price  = p.variants && p.variants[0]
        ? parseFloat(p.variants[0].price).toFixed(2).replace('.', ',')
        : '';
      const description = p.body_html
        ? p.body_html.replace(/<[^>]*>/g, '').trim().substring(0, 60)
        : '';
      return [
        '<div class="quiz-result-card">',
        '  <div class="quiz-result-card__img">',
           imgSrc ? '<img src="' + imgSrc + '" alt="' + p.title + '" loading="lazy">' : '',
        '  </div>',
        '  <div class="quiz-result-card__collection label">' + label + '</div>',
        '  <div class="quiz-result-card__name">' + p.title + '</div>',
        '  <div class="quiz-result-card__fragrance">' + description + '</div>',
        '  <div class="quiz-result-card__price">' + price + ' \u20ac</div>',
        '  <a href="/products/' + p.handle + '" class="btn btn--light" style="margin-top:.8rem;font-size:.62rem;">D\u00e9couvrir</a>',
        '</div>'
      ].join('');
    }).join('');
  }

  // ---- Fallback statique ----
  const fallbackData = {
    'COLLECTION VOYAGE': [
      { title: 'Bali',   body_html: 'Fleurs de Frangipannier', variants: [{ price: '15.00' }], images: [], handle: 'bougie-parfume-jesmonite-bali-fleurs-de-frangipannier' },
      { title: 'Tokyo',  body_html: 'Fleurs de Cerisier',       variants: [{ price: '15.00' }], images: [], handle: 'bougie-parfume-jesmonite-tokyo-fleurs-de-cerisier' },
      { title: 'Duba\u00ef',  body_html: 'Oud & \u00c9pices', variants: [{ price: '15.00' }], images: [], handle: 'bougie-parfumee-jesmonite-dubai-oud-epices' }
    ],
    'COLLECTION AMBIANCE': [
      { title: 'New York',    body_html: 'Cookie Chocolat',  variants: [{ price: '15.00' }], images: [], handle: 'bougie-jesmonite-new-york-cookie-chocolat' },
      { title: 'Madagascar',  body_html: 'Vanille',          variants: [{ price: '15.00' }], images: [], handle: 'bougie-madagascar' },
      { title: 'Iced Coffee Latte', body_html: 'Caf\u00e9, Lait & Vanille', variants: [{ price: '19.00' }], images: [], handle: 'bougie-iced-coffee-latte-candelia-cafe-bougie-parfumee-170g-350g-effet-boisson-glacee' }
    ],
    'COFFRETS CADEAUX': [
      { title: 'Coffret Duo Bougies Voyage', body_html: '2 bougies Jesmonite', variants: [{ price: '35.00' }], images: [], handle: 'coffret-duo-bougies-voyage-250g-130g' },
      { title: 'Coffret Br\u00fbleur + Fondant', body_html: 'Br\u00fbleur Jesmonite + Fondant parfum\u00e9', variants: [{ price: '22.00' }], images: [], handle: 'coffret-bruleur-jesmonite-fondant-parfume' },
      { title: 'Coffret \u00c9vasion', body_html: 'Bougie + Poudre parfum\u00e9e', variants: [{ price: '18.00' }], images: [], handle: 'coffret-evasion-poudre-parfumee-bougie-voyage-130g' }
    ]
  };

  // ---- Afficher les résultats ----
  function showResults() {
    steps.forEach(function (s) { s.classList.remove('active'); });
    if (!results) return;
    results.classList.add('active');
    if (progressFill) progressFill.style.width = '100%';
    if (progressText) progressText.textContent = 'R\u00e9sultat';

    const config = getRecommendationConfig();
    const grid   = results.querySelector('.quiz-results__products');
    if (!grid) return;

    const subtitle = results.querySelector('.quiz-results__subtitle');
    if (subtitle) {
      subtitle.textContent = config.label === 'COFFRETS CADEAUX'
        ? 'Ces coffrets sont faits pour toi ou pour offrir.'
        : 'Voil\u00e0 les bougies faites pour toi.';
    }

    grid.innerHTML = '<div style="grid-column:1/-1;text-align:center;padding:2rem;color:var(--sable);">Chargement de tes recommandations\u2026</div>';

    getProducts(config)
      .then(function (products) {
        if (products.length === 0) {
          renderCards(grid, fallbackData[config.label] || fallbackData['COLLECTION VOYAGE'], config.label);
        } else {
          renderCards(grid, shuffle(products), config.label);
        }
      })
      .catch(function () {
        renderCards(grid, fallbackData[config.label] || fallbackData['COLLECTION VOYAGE'], config.label);
      });
  }

  // ---- Progression ----
  function updateProgress() {
    const pct = (current / steps.length) * 100;
    if (progressFill) progressFill.style.width = pct + '%';
    if (progressText) progressText.textContent = '\u00c9tape ' + (current + 1) + ' / ' + steps.length;
  }

  function showStep(index) {
    steps.forEach(function (s, i) { s.classList.toggle('active', i === index); });
    if (results) results.classList.remove('active');
    updateProgress();
  }

  showStep(0);

  // ---- Clic sur une option — délégation d'événement sur .quiz-options ----
  // Cette approche est fiable peu importe si le clic atterrit sur l'emoji,
  // le label ou la description — e.target.closest() remonte toujours au bon .quiz-option
  steps.forEach(function (step) {
    var container = step.querySelector('.quiz-options');
    if (!container) return;
    container.addEventListener('click', function (e) {
      if (!step.classList.contains('active')) return;
      var option = e.target.closest('.quiz-option');
      if (!option) return;
      step.querySelectorAll('.quiz-option').forEach(function (o) { o.classList.remove('selected'); });
      option.classList.add('selected');
      var stepIndex = Array.from(steps).indexOf(step);
      answers[stepIndex] = option.dataset.value;
      setTimeout(function () {
        if (current < steps.length - 1) { current++; showStep(current); }
        else { showResults(); }
      }, 350);
    });
  });

  document.querySelectorAll('[data-quiz-next]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (current < steps.length - 1) { current++; showStep(current); }
      else { showResults(); }
    });
  });

  document.querySelectorAll('[data-quiz-prev]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (current > 0) { current--; showStep(current); }
    });
  });

  const restartBtn = document.querySelector('[data-quiz-restart]');
  if (restartBtn) {
    restartBtn.addEventListener('click', function () {
      current = 0;
      Object.keys(answers).forEach(function (k) { delete answers[k]; });
      steps.forEach(function (s) {
        s.querySelectorAll('.quiz-option').forEach(function (o) { o.classList.remove('selected'); });
      });
      showStep(0);
    });
  }
});
